<template>
  <fin-data-loader :resolver="filters" @input="val => filtersLoaded(val)">
    <template #content>
      <div v-if="!hideFilter">
        <div v-for="(item, index) in filterDefinitions.filter.items"
             :key="index"
             style="display: inline;">
          <fin-dropdown
            v-if="item.filterValues.values.length > 0"
            :items="item.filterValues.values"
            :label="item.name"
            :value="selectedValues.find(sv => sv.id === shortenedId(item.id)).values"
            output-label-attribute="name"
            @input="val => selectionChanged(item.id, val)"/>
        </div>

        <div v-if="selectedValues.filter(sv => sv.values.length > 0).length > 0"
             class="mt-3">
          <div class="mr-2"
               style="font-weight: bold; display: inline-block;">
            Aktive Filter
            <v-btn
              v-if="selectedValues.filter(sv => sv.values.length > 0).length > 1 || selectedValues.filter(sv => sv.values.length > 1).length > 0"
              icon
              x-small
              @click="removeAllActiveFilters">
              <v-icon>icon-delete</v-icon>
            </v-btn>
            <span>:</span>
          </div>

          <template v-for="filter in selectedValues.filter(sv => sv.values.length > 0)">
            <!-- line-height -->
            <fin-tag v-for="item in filter.values"
                     :key="filter.filterItem + '_' + item.id"
                     class="mr-2"
                     style="display: inline-block;line-height: 30px">
              {{ item.name }}
              <v-btn icon
                     x-small
                     @click="removeFilter(filter.id, item.id)">
                <v-icon>icon-close-small</v-icon>
              </v-btn>
            </fin-tag>
          </template>
        </div>
      </div>
      <!-- @slot useful for nesting dependent components like e.g. fin-data-table -->
      <slot/>
    </template>
  </fin-data-loader>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import FinDropdown from "@/components/common/Dropdown"

export default {
  name: "FinDynamicEtfFilterDisplay",
  components: {FinDropdown, FinDataLoader},
  props: {
    /** Value, Promise or Function (that returns a Promise or value) returning the dynamic filters */
    filters: {},
    /** If the default filters are ignored none is selected initially */
    ignoreDefaultFilters: {
      type: Boolean,
      default: false
    },
    /** Used to hide the display of the filter while still applying the filter */
    hideFilter: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      filterDefinitions: [],
      selectedValues: []
    }
  },
  methods: {
    filtersLoaded(filters) {
      if (filters.filter.items && filters.filter.items.length > 1) {
        // the filter items must be sorted at the frontend
        filters.filter.items.sort((a, b) => a.orderNumber - b.orderNumber)

        // the filter options must be sorted at the frontend
        filters.filter.items.forEach(i => i.filterValues.values.sort((a, b) => a.orderNumber - b.orderNumber))
      }

      const ignore = this.ignoreDefaultFilters
      if (filters.filter.items) {
        filters.filter.items.forEach(f => {
          const defVals = f.defaultValues

          let preselection = []
          if (!ignore && defVals && defVals.length > 0) {
            preselection = f.filterValues.values.filter(v => defVals.includes(v.id))
          }

          this.selectedValues.push({
            id: this.shortenedId(f.id),
            filterItem: f.filterItem,
            values: preselection
          })
        })

        this.emitSelectedValuesChanged()
      }

      this.filterDefinitions = filters
    },
    shortenedId(itemId) {
      return itemId.replace(this.etfFilterClass + "_", "")
    },
    selectionChanged(itemId, val) {
      const index = this.selectedValues.findIndex(sv => sv.id === itemId)

      if (index !== -1) {
        const newFilter = {
          id: itemId,
          filterItem: this.selectedValues[index].filterItem,
          values: val
        }

        this.selectedValues.splice(index, 1, newFilter)

        this.emitSelectedValuesChanged(this.selectedValues[index])
      }
    },
    emitSelectedValuesChanged(changedFilter) {
      const returnObj = {
        activeFilters: this.selectedValues.filter(sv => sv.values.length > 0),
        changedFilter
      }

      /**
       * Emits all activeFilters filters + the changed filter.
       *
       * returnObj -> {
       *   activeFilters,
       *   changedFilter
       * }
       */
      this.$emit('input', returnObj)
    },
    removeFilter(filterId, itemId) {
      const filter = this.selectedValues.find(sv => sv.id === filterId)
      const removeIndex = filter.values.findIndex(f => f.id === itemId)

      // remove the found filter option by index
      filter.values.splice(removeIndex, 1)

      this.emitSelectedValuesChanged(filter)
    },
    removeAllActiveFilters() {
      this.$confirm({
        title: 'Filter löschen',
        text: `Möchtest du alle aktiven Filter zurücksetzen.`,
        dialogWidth: 300,
        confirmBtn: 'Ja'
      })
        .then(() => {
          this.selectedValues.forEach(f => f.values = [])

          this.emitSelectedValuesChanged(null)
        })
    },
  },
}
</script>

<style scoped>

</style>
